import Cookies from 'js-cookie';

const getRequestHeaders = () => {
  const headers = {
    Accept: 'application/json;version=1',
    'X-CSRF-TOKEN': Cookies.get('csrf-token'),
    'X-Box-Client-Name': __APPNAME__ || undefined, // webpack compile time global
    'X-Box-Client-Version': __VERSION__ || undefined, // webpack compile time global
  };
  return headers;
};

export default getRequestHeaders;
